"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const defaultAudio = ['mp3', 'wav', 'mpeg'];
const defaultAudioMimes = defaultAudio.map(ext => `audio/${ext}`);
const defaultVideo = ['mp4', 'm4a', 'fmp4', 'mkv', 'flv', 'webm'];
const defaultVideoMimes = defaultVideo.map(ext => `video/${ext}`);
const defaultImage = ['png', 'jpeg', 'jpg', 'bmp', 'gif'];
const defaultImageMimes = defaultImage.map(ext => `image/${ext}`);
function toMime(txt, type) {
    const prefix = `${type}/`;
    if (txt.includes(prefix))
        return txt;
    return `${prefix}${txt.replace(prefix, '')}`;
}
function getAudioMimes(acceptAudio) {
    if (lodash_1.default.isBoolean(acceptAudio))
        return defaultAudioMimes;
    if (lodash_1.default.isString(acceptAudio))
        return [toMime(acceptAudio, 'audio')];
    return lodash_1.default.map(acceptAudio, acceptItem => toMime(acceptItem, 'audio'));
}
function getVideoMimes(acceptVideo) {
    if (lodash_1.default.isBoolean(acceptVideo))
        return defaultVideoMimes;
    if (lodash_1.default.isString(acceptVideo))
        return [toMime(acceptVideo, 'video')];
    return lodash_1.default.map(acceptVideo, acceptItem => toMime(acceptItem, 'video'));
}
function getImageMimes(acceptImage) {
    if (lodash_1.default.isBoolean(acceptImage))
        return defaultImageMimes;
    if (lodash_1.default.isString(acceptImage))
        return [toMime(acceptImage, 'image')];
    return lodash_1.default.map(acceptImage, acceptItem => toMime(acceptItem, 'image'));
}
function getFile(options) {
    let { accept = '', acceptVideo = false, acceptImage = false, acceptAudio = false } = options || {};
    let formats = [];
    if (acceptVideo)
        formats = formats.concat(getVideoMimes(acceptVideo));
    if (acceptImage)
        formats = formats.concat(getImageMimes(acceptVideo));
    if (acceptAudio)
        formats = formats.concat(getAudioMimes(acceptAudio));
    accept += formats.join(',');
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept || '*';
    input.className = 'web-file-input-element';
    input.style.display = 'none';
    document.body.appendChild(input);
    return new Promise((resolve, reject) => {
        const listener = async (event) => {
            if (!event.target)
                return close(event, reject);
            const { files } = event.target;
            if (!files || !files[0])
                return close(event, reject);
            const file = files[0];
            close(event, () => resolve(file));
        };
        /**
         * there no reliable way to monitor cancel event.
         * onBlur can be, but it is called on wrong moment and multiple times
         */
        input.addEventListener('change', listener);
        input.click();
        function close(event, cb) {
            input.remove();
            input.removeEventListener('change', listener);
            event.target.value = '';
            cb();
        }
    });
}
exports.default = {
    getFile,
};
